import camelCaseKeys from "camelcase-keys";

import { getJsonRequest } from "Helpers/ApiRequest";

import { Menu, MenuSchema } from "./schema";

export const getMenu = async (menuUuid: string): Promise<Menu> => {
  const { body: menuResponse } = await getJsonRequest({
    url: `/marketing_api/menus/${menuUuid}`,
  });

  return MenuSchema.parse(camelCaseKeys(menuResponse, { deep: true }));
};
